import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Box, Button, Card, CardContent, Container, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';
import Styles from '../common/styles/styles';
import { useUser } from '../../userContext';
import SimModal from './modals/simModal';

export default function Simulator() {  
    const [loading, setLoading] = useState(true);
    const { userName } = useUser();
    const textFieldStyles = Styles.textFieldStyles;

    const [formData, setFormData] = useState({ userName: userName, simTypeId: '', simType: '' });
    const [attacks, setAttacks] = useState([]);
    const [displaySimModal, setDisplaySimModal] = useState(false);
    const [title, setTitle] = useState("");

    const handleInputChange = (field) => (e) => {
        let value = e.target.value;

        if (field === 'simTypeId') {
          const type = attacks.find(attack => attack.id === value);
          setFormData({ ...formData, [field]: value, simType: type.value });
          setTitle(type.label);
        } else {
          setFormData({ ...formData, [field]: value });
        }
    }

    const handleSubmit = async (event) => {        
      try {
        toast.success('Simulation In Progress!', { autoClose: 3000 });
        await simulateAttack(event);
      } catch (error) {
          toast.error('Simlation Failed : ', error);
      }
    }

    const resetSimulator = () => {
      setFormData({ ...formData, simTypeId: '', simType: '' });
    }

    const handleSimModalClose  = async () => {        
        setDisplaySimModal(false);
        sendSimulatorEmail();
        resetSimulator();
    }

    const fetchActiveAttacks = async () => {
        try {
                
            const response = await fetch(`${process.env.REACT_APP_API}/attackTypes/activeAttacks`);            
            if (!response.ok) {
                toast.error(`HTTP error! status: ${response.status}`);
            } else {
                const json = await response.json();
                setAttacks(json.data);
            }
        } catch (error) {
            toast.error(error);
        } 
    }

    const sendSimulatorEmail = async () => {
      try {
        const response = await fetch((`${process.env.REACT_APP_API}/simulator/simulate`), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            });
              
            const result = await response.json();
              
            if (result.message === 'success') {
                toast.success('Simulation Succesful.');
                resetSimulator();
            } else {
                toast.error('Simulation Failed');
                resetSimulator();
            }
      } catch (error) {
          toast.error('Network error. Please try again: ', error);
      }
    }

    const simulateAttack = async (event) => {
        try {            
            event.preventDefault();
            if ( (formData.simType === 'unauthorizedApplication') || (formData.simType === 'unauthorizedService') ) {
              await setDisplaySimModal(true);
            } else {
              await sendSimulatorEmail();
            }
        } catch (error) {
            toast.error('Network error. Please try again: ', error);
        }
    };

    useEffect( () => {
      fetchActiveAttacks();
      setLoading(false);
    }, []);

    if (!loading) {
      return (
          <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
                { displaySimModal && 
                  <SimModal title={title} item={formData} onTriggerCloseSimModal={handleSimModalClose}/>
                }
                <Box sx={{pt: 2}}>
                    <ClassificationBannerHeader></ClassificationBannerHeader>
                    <PageHeader title="Simulate Attack"></PageHeader>
                </Box>
                <Box>
                    <Card sx={{
                          mx: 'auto',
                          bgcolor: 'inherit',
                          p: 2,
                          mt: 2,
                        }}>
                        <CardContent>
                            <Typography variant="body2" color="#C8C3BC" sx={{mb: 2}}>
                                <b>STIG:</b> "Security Technical Implementation Guide" is one type of governance on system compliance required by mandate.  It provides compliance verification and mitigation / enforcement.  The security team uses the default mitigation or overrides this to take no action.
                            </Typography>
                            <Typography variant="body2" color="#C8C3BC" sx={{mb: 2}}>
                                <b>Application Active Response:</b> Initiates an application installation on a host system.  Phen will detect, alert and process the finding until the application is either authorized or removed.  Phen will use the security team details on the finding and provide them time to respond.  If they do not take action, Phen will, by default, remove the application and provide proper updates to the security team and the CheckMate software.
                            </Typography>
                            <Typography variant="body2" color="#C8C3BC">
                                <b>Service Active Response:</b> Enables a service on a host system.  Phen will detect, alert and process the finding until the application is either authorized or the service is turned off.  Phen will use the security team details on the finding and provide them time to respond.  If they do not take action, Phen will, by default, remove the application and provide proper updates to the security team and the CheckMate software.
                            </Typography>
                        </CardContent>
                    </Card>
                  </Box>
                <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                    mx: 'auto',
                    width: 400,
                    bgcolor: '#1e1e1e',
                    p: 2,
                    mt: 2,
                  }}
                >
                  <Box component="form" onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                      <TextField
                          select 
                          required
                          fullWidth
                          label="Attack Type"
                          value={formData.simTypeId}
                          onChange={handleInputChange('simTypeId')}
                          sx={ textFieldStyles }
                        >
                          {attacks.map((attack) => (
                            <MenuItem key={attack.id} value={attack.id}>
                              {attack.label}
                            </MenuItem>
                          ))}
                      </TextField>        
                                
                      <Button
                          type="submit"                      
                          fullWidth
                          variant="contained"
                          sx={{
                                  bgcolor: '#303F9F',
                                  textTransform: 'none',
                                  alignSelf: 'flex-start',
                                  mt: 1,
                                  ml: 4,
                                  '&:hover': {
                                  bgcolor: '#303F9F',
                                  },
                                  '&:disabled': {
                                  bgcolor: 'rgba(255, 255, 255, 0.12)',
                                  },
                          }}
                      >
                      Attack
                      </Button>
                    </Stack>
                  </Box>
                </Box>
              </Container>
      )
    }
}